module.exports = BusinessManagerAPI;


//////////////////
// WEBPACK FOOTER
// external "BusinessManagerAPI"
// module id = 227
// module chunks = business-manager/mini-home app-settings/app-settings business-manager/video-library-page business-manager/video-module shoutout/shoutout business-manager/shoutout-popup mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard full-screen-modals/full-screen-modals